// @flow
import React, { Component } from 'react';
import { Dimensions, StyleSheet, View } from 'react-native';
import { Button, Text } from 'trpc-react-native-ui';

import { Icon, ConfirmationModal } from '../../../../../../components/common';
import theme from '../../../../../../theme-config';
import I18n from '../../../../../../lib/i18n';

export default class Details extends Component<Props> {
  styles = getStyles();

  render() {
    return (
      <View style={this.styles.bonusDetailContainer}>
        <Icon
          name={this.props.icon}
          color={this.props.isInvalid ? theme.gray.light : theme.transparentIconColor}
          size={26}
        />
        <View style={this.styles.textContainer}>
          <Text style={this.styles.text}>{this.props.title}</Text>
          <Text style={this.styles.legend}>{this.props.subtitle}</Text>
        </View>
        {this.props.canBeDeleted && (
          <ConfirmationModal
            ButtonComponent={
              <Button hitSlop={{ top: 20, bottom: 20, left: 20, right: 20 }}>
                <Icon name="cross" color={theme.signUpDarkTextColor} size={16} />
              </Button>
            }
            onConfirm={this.props.onDelete}
            title={I18n.t('SignUp.ConfirmPlan.deleteConfirmationModal.title')}
            confirmContent={I18n.t('SignUp.ConfirmPlan.deleteConfirmationModal.subtitle')}
            style={this.styles.deleteButtonContainer}
          />
        )}
      </View>
    );
  }
}

type Props = {
  icon: string,
  title: string,
  subtitle: string,
  isInvalid?: boolean,
  canBeDeleted: boolean,
  onDelete?: Function,
};

const getStyles = () => {
  return StyleSheet.create({
    text: {
      fontWeight: '600',
      fontSize: 14,
      color: theme.signUpDarkTextColor,
    },
    legend: {
      fontWeight: '300',
      fontSize: 13,
      color: theme.signUpDarkTextColor,
      flexWrap: 'wrap',
      flex: 1,
      width: Dimensions.get('window').width - 75,
    },
    textContainer: {
      marginLeft: 16,
      backgroundColor: 'transparent',
      flex: 1,
    },
    bonusDetailContainer: {
      flexDirection: 'row',
      justifyContent: 'flex-start',
      backgroundColor: 'transparent',
      marginVertical: 10,
      alignItems: 'center',
    },
    deleteButtonContainer: {
      alignSelf: 'flex-start',
    },
  });
};
